import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Error404PageComponent } from './pages/error404-page/error404-page.component';
import { CustomTableModule } from '@shared/components/custom-table/custom-table.module';
import { FlexModule } from '@ngbracket/ngx-layout';
import { CustomDatePipe } from '@shared/pipes/custom-date.pipe';
import { EmptyFieldPlaceholderPipe } from '@shared/pipes/empty-field-placeholder.pipe';
import { CheckPermissionDirective } from '@core/helpers/check-permission.directive';
import { CheckRoleDirective } from '@core/helpers/check-role.directive';
import { RemoveInnerHtmlPipe } from '@shared/pipes/remove-inner-html.pipe';
import { LeadingZerosPipe } from '@shared/pipes/leading-zeros.pipe';
import { FilterMappedFieldPipe } from '@shared/pipes/filter-mapped-field.pipe';
import { GroupTypePipe } from './pipes/group-type.pipe';
import { JoinStringsPipe } from './pipes/join-string.pipe';
import { BreadcrumbModule } from './components/breadcrumb/breadcrumb.module';
import { CustomFieldValuesComponent } from './components/custom-field-values/custom-field-values.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    CustomTableModule,
    FlexModule,
    BreadcrumbModule,
    MatDialogModule,
    MatButtonModule,
  ],
  declarations: [
    Error404PageComponent,
    CustomDatePipe,
    EmptyFieldPlaceholderPipe,
    LeadingZerosPipe,
    FilterMappedFieldPipe,
    RemoveInnerHtmlPipe,
    CheckPermissionDirective,
    CheckRoleDirective,
    GroupTypePipe,
    JoinStringsPipe,
    CustomFieldValuesComponent,
  ],
  exports: [
    CommonModule,
    CustomDatePipe,
    EmptyFieldPlaceholderPipe,
    LeadingZerosPipe,
    FilterMappedFieldPipe,
    RemoveInnerHtmlPipe,
    CheckPermissionDirective,
    CheckRoleDirective,
    GroupTypePipe,

    BreadcrumbModule,
    JoinStringsPipe,
    CustomFieldValuesComponent
  ],
  providers: [EmptyFieldPlaceholderPipe],
})
export class SharedModule {}
